module.exports = __webpack_public_path__ + "img/dynamic2.51ef7899.png";